import {
  FETCH_PAYMENT_METHODS,
} from '../../mutation-types';

export default {
  [FETCH_PAYMENT_METHODS](state, paymentMethods) {
    state.paymentMethods = paymentMethods;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/paymentMethods/mutations.js